
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
// Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable  */
import react_1 from "react";

import { GET,dbGET } from "../../webServices/fetch.js";
import { windowLocation } from "../../helpers/common.js";
import SearchIcon from "@material-ui/icons/Search";
import spinner from "../../assets/spinner.png"
const HeaderSearch = (props) => {
    const [data, setData] = react_1.useState([]);
    const [searchString, setSearchString] = react_1.useState("");
    const [options, setOptions] = react_1.useState([]);
    const [searching, setSearching] = react_1.useState(false);
    react_1.useEffect(() => {
        
        filter(searchString, data);
        //setData(data);
        //setOptions(props.data)
    }, [data]);
    const uniqByKeepFirst = (a, key) => {
        const seen = new Set();
        return a.filter((item) => {
            const k = key(item);
            return seen.has(k) ? false : seen.add(k);
        });
    };
    // const checkIfClickedOutside = e => {
        // If the menu is open and the clicked target is not within the menu,
        // then close the menu
        // if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        //   setIsMenuOpen(false)
        // }
        // console.log(e);
        // setOptions([]);
    //   }
  
    //   document.addEventListener("mousedown", checkIfClickedOutside);
    const filter = (search, data) => {
        if (search) {
            // const filteredOptions = options?.filter(
            //   (option) => option.title.toLowerCase().indexOf(search.toLowerCase()) > -1
            // )
            if (data.length==0 && search !==""){

                setOptions([{"children":[],"name":"notfond","title":"Search Results: Not Found!","key":"notfound"}]);  
            }else {
                let filterArray = [];
                data.filter((item) => {
                    item.children.filter((children) => {
                        const childrenItem = children.title.toLowerCase().indexOf(search.toLowerCase()) > -1;
                        if (childrenItem) {
                            const isSameArray = filterArray.filter((filterItem, index) => {
                                if (filterItem.name === item.name) {
                                    const newChildren = filterArray[index].children.concat(children);
                                    filterArray[index] = Object.assign(Object.assign({}, filterArray[index]), { children: newChildren });
                                }
                            });
                            if (isSameArray.length < 1) {
                                filterArray.push(Object.assign(Object.assign({}, item), { children: [children] }));
                            }
                            const uniqueChars = uniqByKeepFirst(filterArray, (it) => it.name);
                            filterArray = uniqueChars;
                        }
                    });
                });
                //setOptions(filterArray);
                setOptions(data);
              
            }
            
            
        } else {
            setOptions([]);
        }
    };
    const onChange = async (e) => {
    const search = e.target.value;
    setSearchString(search);
    if(search){
        if(search.length >= 3){
            setSearching(true);
            const { data: Items } = await dbGET(`v1/search?text=${search}`)
        if (Items) {
          setData(Items);
          setSearching(false);
          filter(search, Items);
          } 
        }
        
    }
    };
    const onKeyUp = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if(charCode === 27){
          setOptions([]);
          e.target.value = '';
        }
        if (charCode === 8) {
            const search = e.target.value;
            filter(search, data);
        }
        if (charCode === 13) {
            const search = e.target.value;
            windowLocation(`${window.location.origin}/marketplace?search=${search}`)
        }
    };
    // const createImg = () => {
    //     alert(1);
    // }
    return (react_1.createElement(react_1.Fragment, null,
        react_1.createElement("div", { className: "p-2" },
            react_1.createElement("input", { placeholder: "Search", 
                //   value={props.value}
                className: "leading-4 p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-base border border-gray-300 rounded-md", onKeyUp: onKeyUp, onChange: onChange }),
            options
                ? (options === null || options === void 0 ? void 0 : options.length) > 0 && (react_1.createElement("div", { className: "mt-1" },
                    react_1.createElement("ul", { className: "bg-white p-2 rounded-sm",dataMyattribute:'1212' }, options === null || options === void 0 ? void 0 : options.map((item, index) => (react_1.createElement(react_1.Fragment, null,
                        react_1.createElement("li", { key: index, className: "text-gray-400" }, item.title),
                        react_1.createElement("ul", { className: "ml-4",dataMyattribute:'1212' }, item.children.map((children, childrenIndex) => (
                            react_1.createElement("li", { key: childrenIndex,id:'xxx'+childrenIndex, className: "hover:bg-gray-200 focus:outline-none  cursor-pointer mnmm", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                let url = window.location.href;
                                let domain = (new URL(url));
                                
                                domain = domain.hostname;
                                // alert(domain);
                                if(domain == 'localhost'){
                                    // localhost:3000/
                                    domain = 'http://'+domain+':3000/asset/'+children.url;//'0x495f947276749ce646f68ac8c248420045cb7b5e/67154617034340034456453366385792604942607367955217100128958638024804863574017'
                                }else{
                                    domain = 'https://mintjar.co/asset/'+children.url
                                }
                                window.location.href = domain;

                                setOptions([]);
                            }) },react_1.createElement('img',{ src: children.imgUrl+"=h50", style: {width: '24px',marginRight:'10px',height:'24px',borderRadius:'50%'} }),children.title))))))))))
                            
                : null),
                searching ? (
                    
                    <img src={spinner} style={{position: 'absolute',height:'32px',zIndex: 1,top: '2px',right:'8px',}} />
                ) : null
                
                )
                
                
                
                
                
                );
};
// exports.default = HeaderSearch;
export default HeaderSearch;
//# sourceMappingURL=AutocompleteGroupBy.js.map